import React from 'react';

import HomeAboutText from '../about/HomeAboutText';
import HomeAboutImg from '../about/HomeAboutImg';

const AboutUs = () => {
    return (
        <section id="about-us" className="block spacer p-top-xl">
            <HomeAboutText />

            <HomeAboutImg />           
        </section>
    );
};

export default AboutUs;
